// extracted by mini-css-extract-plugin
module.exports = {"container":"CartHeader_container__1Wc0c","img":"CartHeader_img__mZyG0","cartIcon":"CartHeader_cartIcon__1xPgf","header":"CartHeader_header__3IgHM"};